export enum paceStatusIcon {
    "Completed" = "paceIconColouredDark",
    "Incomplete" = "paceIconGrayedOut",
    "Not Sharing" = "paceIconNotShared",
    "Not started" = "paceIconGrayedOut",
}
